import { render } from "./TestComponent.vue?vue&type=template&id=34f1fb59"
import script from "./TestComponent.vue?vue&type=script&lang=js"
export * from "./TestComponent.vue?vue&type=script&lang=js"

import "./TestComponent.vue?vue&type=style&index=0&id=34f1fb59&lang=css"

import exportComponent from "C:\\Users\\kimjiwon\\Desktop\\테스트사이트\\메인페이지\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__